import { RosterStatus } from '__generated__/graphql'
import startCase from 'lodash.startcase'

export const rosterStatusOptions = Object.values(RosterStatus).map(
    (status) => ({ id: status, label: startCase(status) })
)

export enum ProcessSummaryStatus {
    'No Status' = 'No Status',
    'Mapping' = 'Mapping',
    'Outreach' = 'Outreach',
    'Interest' = 'Interest',
    'In Process' = 'In Process',
    'Advanced' = 'Advanced',
    'Hired' = 'Hired',
}
